import type { DiagramPage } from '../core/types';
import { Icon, Symbols } from './icons';

interface Props {
  readOnly?: boolean;
  pages: DiagramPage[];
  activePageId: string;
  onActivate: (id: string) => void;
  onAdd: () => void;
  onRename: (id: string, name: string) => void;
  onDuplicate: (id: string) => void;
  onDelete: (id: string) => void;
  onMove: (id: string, direction: 'left' | 'right') => void;
}

export function PageTabs({ readOnly = false, pages, activePageId, onActivate, onAdd, onRename, onDuplicate, onDelete, onMove }: Props) {
  const activeIndex = pages.findIndex((page) => page.id === activePageId);

  return (
    <div className="pagebar" aria-label="Páginas do diagrama">
      <div className="page-tabs">
        {pages.map((page) => {
          const active = page.id === activePageId;
          return (
            <div key={page.id} className={`page-tab-wrap ${active ? 'active' : ''}`}>
              <button
                type="button"
                className="page-tab"
                onClick={() => onActivate(page.id)}
                onDoubleClick={() => {
                  if (readOnly) return;
                  const name = window.prompt('Nome da página', page.name)?.trim();
                  if (name) onRename(page.id, name);
                }}
                title="Duplo clique para renomear"
              >
                <span>{page.name}</span>
              </button>
              {!readOnly && pages.length > 1 && (
                <button
                  type="button"
                  className="page-tab-close"
                  onClick={(event) => { event.stopPropagation(); onDelete(page.id); }}
                  aria-label={`Fechar ${page.name}`}
                  title={`Fechar / excluir ${page.name}`}
                >
                  <Icon>{Symbols.close}</Icon>
                </button>
              )}
            </div>
          );
        })}
        {!readOnly && (
          <button type="button" className="page-add" onClick={onAdd} title="Nova página" aria-label="Nova página">
            <Icon>{Symbols.plus}</Icon>
          </button>
        )}
      </div>
      {!readOnly && (
        <div className="page-actions">
          <button type="button" className="page-action-icon" onClick={() => onMove(activePageId, 'left')} disabled={activeIndex <= 0} title="Mover página para a esquerda">←</button>
          <button type="button" className="page-action-icon" onClick={() => onMove(activePageId, 'right')} disabled={activeIndex >= pages.length - 1} title="Mover página para a direita">→</button>
          <button type="button" className="page-action-button" onClick={() => onDuplicate(activePageId)} title="Duplicar página atual"><Icon>{Symbols.duplicate}</Icon><span>Duplicar</span></button>
          <button type="button" className="page-action-button page-action-danger" disabled={pages.length <= 1} onClick={() => onDelete(activePageId)} title={pages.length <= 1 ? 'O documento precisa ter ao menos uma página' : 'Excluir página atual'}><Icon>{Symbols.trash}</Icon><span>Excluir</span></button>
        </div>
      )}
    </div>
  );
}
